import { defaultVertex, systems, Filter, RenderTexture, utils } from 'pixi.js';
import deferredLighting from '../shaders/fragment/deferredLighting';
import { Resolution } from '../../../../shared/constants';
import { BackgroundFluid } from '../backgroundFluid';
import { Colors } from '../../palettes/colorPalette';

export class DeferredRenderPass extends Filter {

	scaleFactor = 1.0;

	constructor(public depthBuffer: PIXI.RenderTexture, public background: BackgroundFluid) {
		super(defaultVertex, deferredLighting);
		this.padding = 32;
	}

	/**
	 * Override existing apply method in PIXI.Filter
	 * @private
	 */
	apply(filterManager: systems.FilterSystem, input: RenderTexture, output: RenderTexture, clear: boolean, currentState?: any) {

		this.uniforms.backgroundColorLight = utils.hex2rgb(Colors.Background);
		this.uniforms.backgroundColorDark = utils.hex2rgb(Colors.BackgroundRaised);
		this.uniforms.virusTrailColor = utils.hex2rgb(Colors.VirusTrail);
		this.uniforms.uDepthSampler = this.depthBuffer;
		this.uniforms.texelSize = [(1 / Resolution.Width) * this.scaleFactor, (1 / Resolution.Height) * this.scaleFactor];

		//Grab trail and already calculated transform from background
		this.uniforms.uTrailsTexture = this.background.getTrailsTexture();
		this.uniforms.trailUvOffset = this.background.mesh.shader.uniforms.trailUvOffset;
		this.uniforms.trailUvScaler = this.background.mesh.shader.uniforms.trailUvScaler;

		filterManager.applyFilter(this, input, output, clear);
	}
}